document.addEventListener('DOMContentLoaded', function () {
  var OPEN_HASH = '#open-menu-mobile';
  var CLOSE_HASH = '#close-menu-mobile';

  var menu = document.querySelector('.header__menu-mobile-wrapper');
  if (!menu) return;

  function openMenu() {
    menu.classList.add('is-open');
    document.documentElement.classList.add('no-scroll');
  }

  function closeMenu() {
    menu.classList.remove('is-open');
    document.documentElement.classList.remove('no-scroll');
  }

  function syncWithHash() {
    if (window.location.hash === OPEN_HASH) {
      openMenu();
    } else if (window.location.hash === CLOSE_HASH) {
      closeMenu();
    }
  }

  window.addEventListener('hashchange', syncWithHash);
  syncWithHash();

  document.addEventListener('click', function (event) {
    if (!menu.classList.contains('is-open')) return;
    if (menu.contains(event.target)) return;
    if (event.target.closest('a[href="' + OPEN_HASH + '"]')) return;

    window.location.hash = 'close-menu-mobile';
  });
});
